import { render } from "./LinkDialog.vue?vue&type=template&id=2ad3bae6"
import script from "./LinkDialog.vue?vue&type=script&lang=js"
export * from "./LinkDialog.vue?vue&type=script&lang=js"

import "./LinkDialog.vue?vue&type=style&index=0&id=2ad3bae6&lang=scss"
script.render = render

export default script